import { render, staticRenderFns } from "./postSaleStep.vue?vue&type=template&id=3006361d&scoped=true&"
import script from "./postSaleStep.vue?vue&type=script&lang=js&"
export * from "./postSaleStep.vue?vue&type=script&lang=js&"
import style0 from "./postSaleStep.vue?vue&type=style&index=0&id=3006361d&prod&lang=less&"
import style1 from "./postSaleStep.vue?vue&type=style&index=1&id=3006361d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006361d",
  null
  
)

export default component.exports